import React, { useEffect, useState } from 'react';
import Header from '../components/header';
import Footers from '../components/footers';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'flowbite-react';
import { AiOutlineLoading } from 'react-icons/ai';
import { serverURL, educationURL } from '../constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';

const Topics = () => {

    const { state } = useLocation();
    const [processing, setProcessing] = useState(false);
    const { jsonData, mainTopic, type, apiUrl, stepperValue } = state || {};
    const navigate = useNavigate();

    useEffect(() => {
        if (!jsonData) {
            navigate("/create");
        }
    }, []);

    useEffect(() => {
        console.log(stepperValue);
        if (stepperValue === 'generate-course') {
            const tourStarter = new Shepherd.Tour({
                defaultStepOptions: {
                classes: 'shadow-md bg-white p-3',
                scrollTo: true,
                },
            });

            tourStarter.addStep({
                id: 'topicDefault-step',
                classes: 'process-bar-custom inline-footer',
                title: 'Click Generate Course.',
                text: 'View and generate your course modules.',
                attachTo: {
                    element: '.course-generate-fikra',
                    on: 'right',
                },
                buttons: [
                    {
                        text: '',
                        classes: 'close-stepper-btn',
                        action: tourStarter.cancel,
                    },
                    {
                    text: '3/5',
                    classes: 'stepper-details',
                    },
                    {
                    text: 'Back',
                    classes: 'action-normal back-style',
                    action: () => {
                            window.location.href = 'https://edu.fikrahub.com/dashboard/user/student?stepNumber=2&stepper=' + stepperValue;
                        }
                    },
                    {
                        text: 'Next',
                        classes: 'action-normal next-style',
                        action: () => {
                            redirectCourse();
                            tourStarter.cancel();
                        },
                    },
                ],
            });

            tourStarter.start();
        }
    }, []);

    function redirectCreate() {
        navigate("/create");
    }

    const showToast = async (msg) => {
        toast(msg, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
        });
    }


    function redirectCourse() {

        const mainTopicData = jsonData[mainTopic][0];

        const firstSubtopic = mainTopicData.subtopics[0];

        if (type === 'video & text course') {

            const query = `${firstSubtopic.title} ${mainTopic} in english`;
            sendVideo(query, firstSubtopic.title);
            setProcessing(true);

        } else {

            const prompt = `Explain me about this subtopic of ${mainTopic} with examples :- ${firstSubtopic.title}. Please Strictly Don't Give Additional Resources And Images.`;
            const promptImage = `Example of ${firstSubtopic.title} in ${mainTopic}`;
            setProcessing(true);
            sendPrompt(prompt, promptImage);

        }

    }

    async function sendPrompt(prompt, promptImage) {
        const dataToSend = {
            prompt: prompt,
        };
        try {
            const postURL = serverURL + '/api/generate';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.text;
            const htmlContent = generatedText;

            try {
                const parsedJson = htmlContent;
                sendImage(parsedJson, promptImage);
            } catch (error) {
                sendPrompt(prompt, promptImage)
            }

        } catch (error) {
            sendPrompt(prompt, promptImage)
        }
    }

    async function sendImage(parsedJson, promptImage) {
        const dataToSend = {
            prompt: promptImage,
        };
        try {
            const postURL = serverURL + '/api/image';
            const res = await axios.post(postURL, dataToSend);
            try {
                const generatedText = res.data.url;
                sendData(generatedText, parsedJson);
                setProcessing(false);
            } catch (error) {
                sendImage(parsedJson, promptImage)
            }

        } catch (error) {
            sendImage(parsedJson, promptImage)
        }
    }

    async function sendData(image, theory) {
        jsonData[mainTopic][0].subtopics[0].theory = theory;
        jsonData[mainTopic][0].subtopics[0].image = image;
    
        const user = sessionStorage.getItem('uid');
        const content = JSON.stringify(jsonData);
        const postURL = serverURL + '/api/course';
        const response = await axios.post(postURL, { user, content, type, mainTopic });
    
        if (response.data.success) {
            showToast(response.data.message);
            sessionStorage.setItem('courseId', response.data.courseId);
            sessionStorage.setItem('first', response.data.completed);
            sessionStorage.setItem('jsonData', JSON.stringify(jsonData));
    
            if (apiUrl) {
                // Call the Laravel API to create a course
                let data = {
                    courses_id: response.data.courseId,
                    email: sessionStorage.getItem('email'),
                    status: 'active',
                    image_url: response.data.photo,
                    topic: mainTopic,
                };
    
                try {
                    const laravelResponse = await axios.post(apiUrl, data);
                    if (laravelResponse.data.success) {
                        console.log("Laravel course creation successful:", laravelResponse.data);
                    } else {
                        console.error("Error creating course in Laravel:", laravelResponse.data.message);
                    }
                } catch (error) {
                    console.error("Error calling Laravel API:", error.message);
                }
            }
            let query = stepperValue ? `?stepper=${stepperValue}` : '';
            navigate(`/course${query}`, { state: { jsonData: jsonData, mainTopic: mainTopic.toUpperCase(), type: type ? type.toLowerCase() : '', courseId: response.data.courseId, end: '' } });
        } else {
            sendData(image, theory);
        }
    }    

    async function sendDataVideo(image, theory) {
        jsonData[mainTopic][0].subtopics[0].theory = theory;
        jsonData[mainTopic][0].subtopics[0].youtube = image;

        const user = sessionStorage.getItem('uid');
        const content = JSON.stringify(jsonData);
        const postURL = serverURL + '/api/course';
        const response = await axios.post(postURL, { user, content, type, mainTopic });

        if (response.data.success) {
            showToast(response.data.message);
            sessionStorage.setItem('courseId', response.data.courseId);
            sessionStorage.setItem('first', response.data.completed);
            sessionStorage.setItem('jsonData', JSON.stringify(jsonData));
            if (apiUrl) {
                // Call the Laravel API to create a course
                let data = {
                    courses_id: response.data.courseId,
                    email: sessionStorage.getItem('email'),
                    status: 'active',
                    image_url: response.data.photo,
                    topic: mainTopic,
                };
    
                try {
                    const laravelResponse = await axios.post(apiUrl, data);
                    if (laravelResponse.data.success) {
                        console.log("Laravel course creation successful:", laravelResponse.data);
                    } else {
                        console.error("Error creating course in Laravel:", laravelResponse.data.message);
                    }
                } catch (error) {
                    console.error("Error calling Laravel API:", error.message);
                }
            }
            navigate('/course', { state: { jsonData: jsonData, mainTopic: mainTopic.toUpperCase(), type: type ? type.toLowerCase() : '', courseId: response.data.courseId, end: '' } });
        } else {
            sendDataVideo(image, theory)
        }

    }

    async function sendVideo(query, subtopic) {
        const dataToSend = {
            prompt: query,
        };
        try {
            const postURL = serverURL + '/api/yt';
            const res = await axios.post(postURL, dataToSend);

            try {
                const generatedText = res.data.url;
                sendTranscript(generatedText, subtopic);
            } catch (error) {
                sendVideo(query, subtopic)
            }

        } catch (error) {
            sendVideo(query, subtopic)
        }
    }

    async function sendTranscript(url, subtopic) {
        const dataToSend = {
            prompt: url,
        };
        try {
            const postURL = serverURL + '/api/transcript';
            const res = await axios.post(postURL, dataToSend);

            try {
                const generatedText = res.data.url;
                const allText = generatedText.map(item => item.text);
                const concatenatedText = allText.join(' ');
                const prompt = `Summarize this theory in a teaching way and :- ${concatenatedText}.`;
                sendSummery(prompt, url);
            } catch (error) {
                const prompt = `Explain me about this subtopic of ${mainTopic} with examples :- ${subtopic}. Please Strictly Don't Give Additional Resources And Images.`;
                sendSummery(prompt, url);
            }

        } catch (error) {
            const prompt = `Explain me about this subtopic of ${mainTopic} with examples :- ${subtopic}. Please Strictly Don't Give Additional Resources And Images.`;
            sendSummery(prompt, url);
        }
    }

    async function sendSummery(prompt, url) {
        const dataToSend = {
            prompt: prompt,
        };
        try {
            const postURL = serverURL + '/api/generate';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.text;
            const htmlContent = generatedText;

            try {
                const parsedJson = htmlContent;
                setProcessing(false);
                sendDataVideo(url, parsedJson);
            } catch (error) {
                sendSummery(prompt, url)
            }

        } catch (error) {
            sendSummery(prompt, url)
        }
    }

    const renderTopicsAndSubtopics = (topics) => {
        try {
            return (
                <div>
                    {topics.map((topic) => (
                        <div key={topic.title}>
                            <h3 className='w-full text-white bg-black px-4 py-2 mt-8 mb-2 font-black text-lg dark:bg-white dark:text-black'>{topic.title}</h3>
                            <div>
                                {topic.subtopics.map((subtopic) => (
                                    <p className='w-full border-black border bg-white px-4 py-2 mb-2 font-normal text-sm dark:text-white dark:border-white dark:bg-black' key={subtopic.title}>{subtopic.title}</p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            );
        } catch (error) {
            return (
                <div>
                    {topics.map((topic) => (
                        <div key={topic.title}>
                            <h3 className='w-full text-white bg-black px-4 py-2 mt-8 mb-2 font-black text-lg dark:bg-white dark:text-black'>{topic.title}</h3>
                            <div>
                                {topic.subtopics.map((subtopic) => (
                                    <p className='w-full border-black border bg-white px-4 py-2 mb-2 font-normal text-sm dark:text-white dark:border-white dark:bg-black' key={subtopic.title}>{subtopic.title}</p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            );
        }
    };


    return (
        <div className='h-screen flex flex-col'>
            <Header isHome={true} className="sticky top-0 z-50" />
            <div className='dark:bg-black flex-1'>
                <div>
                    <div className='max-md:max-w-sm max-sm:max-w-xs max-w-lg m-auto py-10'>
                        <h1 style={{ textTransform: 'uppercase' }} className='text-4xl text-black font-black text-center dark:text-white' >{mainTopic}</h1>
                        <p className='text-center font-bold mt-2 text-base text-black dark:text-white'>List of topics and subtopics course will cover</p>
                        {jsonData && renderTopicsAndSubtopics(jsonData[mainTopic])}
                        <Button onClick={redirectCourse} isProcessing={processing} processingSpinner={<AiOutlineLoading className="h-6 w-6 animate-spin" />} className='course-generate-fikra items-center justify-center text-center dark:bg-white dark:text-black bg-black text-white font-bold rounded-none w-full enabled:hover:bg-black enabled:focus:bg-black enabled:focus:ring-transparent dark:enabled:hover:bg-white dark:enabled:focus:bg-white dark:enabled:focus:ring-transparent mt-10 mb-2'>Generate Course</Button>
                        <Button onClick={redirectCreate} type="button" className='mb-6 items-center justify-center text-center border-black dark:border-white dark:bg-black dark:text-white bg-white text-black font-bold rounded-none w-full enabled:hover:bg-white enabled:focus:bg-white enabled:focus:ring-transparent dark:enabled:hover:bg-black dark:enabled:focus:bg-black dark:enabled:focus:ring-transparent'>Go Back</Button>
                    </div>

                </div>
            </div>
            <Footers className="sticky bottom-0 z-50" />
        </div>
    );
};

export default Topics;